import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {PaymentStore} from '../../../../core/stores/payment.store';
import {BillingAddress} from '../../../../core/models/payment-item.model';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-billing-address',
  templateUrl: './billing-address.component.html',
  styleUrls: ['./billing-address.component.scss']
})
export class BillingAddressComponent implements OnInit, OnDestroy {
  @Input()
  public touched;

  public addressLine1: string;
  public addressLine2: string;
  public addressLine3: string;
  public locality: string;
  public country: string;
  public organization: string;
  public postalCode: string;
  public sublocality: string;
  public sublocality1: string;
  public sublocality2: string;
  public administrativeDistrictLevel1: string;
  public administrativeDistrictLevel2: string;
  public administrativeDistrictLevel3: string;

  private destroyed$ = new Subject<void>();

  public get fieldInvalid(): boolean {
    return !this.paymentStore.billingAddress && this.touched;
  }

  constructor(public paymentStore: PaymentStore) {
  }

  ngOnInit() {
    this.paymentStore.verificationCustomer$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => {
        if (this.paymentStore.billingAddress) {
          this.addressLine1 = this.paymentStore.billingAddress.address_line1;
          this.addressLine2 = this.paymentStore.billingAddress.address_line2;
          this.addressLine3 = this.paymentStore.billingAddress.address_line3;
          this.locality = this.paymentStore.billingAddress.locality;
          this.country = this.paymentStore.billingAddress.country;
          this.organization = this.paymentStore.billingAddress.organization;
          this.postalCode = this.paymentStore.billingAddress.postal_code;
          this.sublocality = this.paymentStore.billingAddress.sublocality;
          this.sublocality1 = this.paymentStore.billingAddress.sublocality1;
          this.sublocality2 = this.paymentStore.billingAddress.sublocality2;
          this.administrativeDistrictLevel1 = this.paymentStore.billingAddress.administrative_district_level1;
          this.administrativeDistrictLevel2 = this.paymentStore.billingAddress.administrative_district_level2;
          this.administrativeDistrictLevel3 = this.paymentStore.billingAddress.administrative_district_level3;
          this.updateBillingAddress();
        }
      })
  }

  ngOnDestroy() {
    this.destroyed$.next();
  }

  public updateBillingAddress(): void {
    const billingAddress: BillingAddress = {
      address_line1: this.addressLine1,
      address_line2: this.addressLine2,
      address_line3: this.addressLine3,
      locality: this.locality,
      country: this.country,
      organization: this.organization,
      postal_code: this.postalCode,
      sublocality: this.sublocality,
      sublocality1: this.sublocality1,
      sublocality2: this.sublocality2,
      administrative_district_level1: this.administrativeDistrictLevel1,
      administrative_district_level2: this.administrativeDistrictLevel2,
      administrative_district_level3: this.administrativeDistrictLevel3,
    };

    this.paymentStore.setBillingAddress(billingAddress);
  }

}
